var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new"},[_c('div',{staticClass:"Reference"},[_c('ReferContent',{attrs:{"dataList":_vm.dataList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }